import './index.scss';
import {jump} from '../../tools';

const SightHotelItem = (props) => {
    const {img = '', jumpInfo = {}, subTitle = '', title = ''} = props.data;
    const eIndex = props.eIndex;
    const type = props.type;
    return <div className="hotel-list-item" key={props.key} data-sk-eid={type === 'sight' ? `abu_tkt_${eIndex}` : `abu_hotel_${eIndex}`}>
        <div className={`${type === 'sight' ? 'sight-top' : 'top'}`} style={{backgroundImage: `url(${img})`}}></div>
        <div className="title">{title}</div>
        <div className={`${type === 'sight' ? 'sight-sub-title' : 'sub-title'}`}>{subTitle}</div>
        <div className="btn" onClick={() => jump(jumpInfo, (type === 'sight' ? 'navibar-none' : ''))}>立即查看</div>
    </div>;
};

export default SightHotelItem;